import React, { useState, useEffect, useRef, useCallback } from "react";
import useDidMount from "./hooks/useDidMount";
import moment from 'moment';
import useDidMountWithTimeout from "./hooks/useDidMountWithTimeout";
import { useDebouncedEffect } from "./hooks/useDebouncedEffect ";
import { SportsCampsContext } from "./context/sportscamps-context";

import AvailabliltyFilter from "./Filters/AvailabilityFilter";
import CareTypeFilter from "./Filters/CareTypeFilter";
import CategoryFilter from "./Filters/CategoryFilter";
import HolidayFilter from "./Filters/HolidayFilter";
import LocationFilter from "./Filters/LocationFilter";
import YearOfBirthFilter from "./Filters/YearOfBirthFilter";
import SportsCampsDetail from "./MoreInfoCard/SportsCampsDetail";
import SportsCampsCard from "./SportsCampsCard";
import SportsCampsResults from "./SportsCampsResults";

import "./search-sports-camps.scss";

const yearOfActivities = new Date().getFullYear();

const apiUrlBase = "/umbraco/api/sportscamps/";

const filtersForCounters = [
	{ Type: "yearOfBirth", YearOfBirth: yearOfActivities - 8 },
	{ Type: "yearOfBirth", YearOfBirth: yearOfActivities - 9 },
	{ Type: "yearOfBirth", YearOfBirth: yearOfActivities - 10 },
	{ Type: "yearOfBirth", YearOfBirth: yearOfActivities - 11 },
	{ Type: "yearOfBirth", YearOfBirth: yearOfActivities - 12 },
	{ Type: "yearOfBirth", YearOfBirth: yearOfActivities - 13 },
	{ Type: "yearOfBirth", YearOfBirth: yearOfActivities - 14 },
	{ Type: "yearOfBirth", YearOfBirth: yearOfActivities - 15 },
	{ Type: "yearOfBirth", YearOfBirth: yearOfActivities - 16 },
	{ Type: "yearOfBirth", YearOfBirth: yearOfActivities - 17 },
	{ Type: "yearOfBirth", YearOfBirth: yearOfActivities - 18 },
	{ Type: "location", LocationName: "Blankenberge" },
	{ Type: "location", LocationName: "Brasschaat" },
	{ Type: "location", LocationName: "Brugge" },
	{ Type: "location", LocationName: "Genk" },
	{ Type: "location", LocationName: "Gent" },
	{ Type: "location", LocationName: "Hasselt" },
	{ Type: "location", LocationName: "Herentals" },
	{ Type: "location", LocationName: "Hofstade" },
	{ Type: "location", LocationName: "Liedekerke" },
	{ Type: "location", LocationName: "Nieuwpoort" },
	{ Type: "location", LocationName: "Oordegem" },
	{ Type: "location", LocationName: "Waregem" },
	{ Type: "location", LocationName: "Willebroek" },
	{ Type: "location", LocationName: "Woumen" },
	{ Type: "careType", CareTypeCode: "INT" },
	{ Type: "careType", CareTypeCode: "EXT - Lunch" },
	{ Type: "careType", CareTypeCode: "EXT + Lunch" },
];

export const SearchSportsCamps = (props) => {	
	const [dictionaryWords, setDictionaryWords] = useState([]);
	const [categories, setCategories] = useState([]);

	const [sportsCamps, setSportsCamps] = useState([]);
	const [sportsCampsCards, setSportsCampsCards] = useState([]);
	const [isLoading, setIsLoading] = useState(false);
	const [isLoadingMore, setIsLoadingMore] = useState(false);
	const [isLoadingDictionary, setIsLoadingDictionary] = useState(false);

	const [page, setPage] = useState(1);

	const [yearOfBirthCounter, setYearOfBirthCounter] = useState([]);
	const [careTypeCounter, setCareTypeCounter] = useState([]);
	const [locationCounter, setLocationCounter] = useState([]);
	const [holidayCounter, setHolidayCounter] = useState([]);

	const [moreInfoVisible, setMoreInfoVisible] = useState(false);
	const [moreInfoCard, setMoreInfoCard] = useState(null);
	const [sportsCampId, setSportsCampId] = useState("");

	const [activityNameSearchTerm, setActivityNameSearchTerm] = useState("");
	const [activityTypeSearchTermCodes, setActivityTypeSearchTermCodes] =
		useState([]);
	const [freePlacesOnly, setFreePlacesOnly] = useState(false);
	const [yearOfBirth, setYearOfBirth] = useState("");
	const [careTypeCode, setCareTypeCode] = useState("");
	const [locations, setLocations] = useState([]);
	const [holiday, setHoliday] = useState("");
	const [from, setFrom] = useState("");
	const [until, setUntil] = useState("");
	const [fromValue, setFromValue] = useState(null);
	const [untilValue, setUntilValue] = useState(null);

	const [categoryButtonsActive, setCategoryButtonsActive] = useState([]);
	const [initCategoryButtonsActive, setInitCategoryButtonsActive] =
		useState(true);
	const [availabilityButtonActive, setAvailabilityButtonActive] =
		useState(false);
	const [yearOfBirthButtonActive, setYearOfBirthButtonActive] =
		useState(false);
	const [careTypeButtonActive, setCareTypeButtonActive] = useState(false);
	const [locationButtonsActive, setLocationButtonsActive] = useState([]);
	const [holidayButtonActive, setHolidayButtonActive] = useState(false);
	const [fromButtonActive, setFromButtonActive] = useState(false);
	const [untilButtonActive, setUntilButtonActive] = useState(false);

	const controllerRef = useRef(null);

	const fetchDictionary = useCallback(async () => {
		setIsLoadingDictionary(true);

		try {
			const response = await fetch(`${apiUrlBase}getfichedictionaries`);

			if (!response.ok) {
				throw new Error("Something went wrong...");
			}

			const data = await response.json();

			setIsLoadingDictionary(false);
			return setDictionaryWords(data);
		} catch (error) {
			console.log(error);
		}
	}, []);

	useEffect(() => {
		addHolidays();
		fetchDictionary();
	}, [fetchDictionary]);

	const addHolidays = () => {
		props.holidays.forEach(el => {
			var from = new Date(el.holidayStartDate)
			var fromHolder = from.toISOString();
			var fromFormatted = moment(fromHolder, 'YYYY-MM-DDTHH:mm:ss.sssZ').format('YYYY-MM-DD h:mm:ss');
			var until = new Date(el.holidayEndDate)
			var untilHolder = until.toISOString();
			var untilFormatted = moment(untilHolder, 'YYYY-MM-DDTHH:mm:ss.sssZ').format('YYYY-MM-DD h:mm:ss')
			var holiday = {
				Type: "period",
				Name: el.holidayName,
				From: `${fromFormatted}`,
				Until: `${untilFormatted}`,
			}
			filtersForCounters.push(holiday)
		});
	}
	

	const fetchSportsCamps = async () => {
		setIsLoading(true);

		if (controllerRef.current) {
			controllerRef.current.abort();
		}

		const controller = new AbortController();
		controllerRef.current = controller;

		try {
			const response = await fetch(apiUrlBase + "SearchSportsCampActivities/", {
				method: "POST",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify({
					activityNameSearchTerm: activityNameSearchTerm,
					activityTypeSearchTermCodes: activityTypeSearchTermCodes,
					careTypeCode: careTypeCode,
					filtersForCounters: filtersForCounters,
					freePlacesOnly: freePlacesOnly,
					holiday: holiday,
					from: from,
					until: until,
					locations: locations,
					page: page,
					yearOfActivities: yearOfActivities,
					yearOfBirth: yearOfBirth,
				}),
				signal: controllerRef.current?.signal,
			});

			if (!response.ok) {
				throw new Error("Something went wrong...");
			}

			controllerRef.current = null;

			const data = await response.json();
			setIsLoading(false);
			return setSportsCamps(data);
		} catch (error) {
			console.log(error);
		}
	};

	const fetchInitSportkamp = async (id) => {
		setIsLoadingMore(true);

		const sportsCampUrl = `${apiUrlBase}GetSportsCampActivity?sportscampActivityId=${id}&yearOfActivity=${yearOfActivities}`;

		try {
			const response = await fetch(sportsCampUrl);

			if (!response.ok) {
				throw new Error("Something went wrong...");
			}

			const data = await response.json();

			setIsLoadingMore(false);
			setMoreInfoVisible(true);
			return setMoreInfoCard(data);
		} catch (error) {
			console.log(error);
		}
	};

	// Retrieve selected sports camp
	const fetchSportsCamp = async () => {
		setIsLoadingMore(true);

		const sportsCampUrl = `${apiUrlBase}GetSportsCampActivity?sportscampActivityId=${sportsCampId}&yearOfActivity=${yearOfActivities}`;

		try {
			const response = await fetch(sportsCampUrl);

			if (!response.ok) {
				throw new Error("Something went wrong...");
			}

			const data = await response.json();

			setIsLoadingMore(false);
			return setMoreInfoCard(data);
		} catch (error) {
			console.log(error);
		}
	};

	// Avoid API call on first render
	useDidMount(() => {
		fetchSportsCamp(sportsCampId);
	}, [sportsCampId]);

	useEffect(() => {
		if (sportsCamps.activities && page === 1) {
			setSportsCampsCards([]);
			const newSportsCamps = [];
			sportsCamps.activities.forEach((sportsCamp) => {
				newSportsCamps.push(
					<SportsCampsCard
						key={sportsCamp.activityId}
						sportsCamp={sportsCamp}
					/>
				);
			});

			setSportsCampsCards([newSportsCamps]);
		} else if (sportsCamps.activities) {
			const newSportsCamps = [];
			sportsCamps.activities.forEach((sportsCamp) => {
				newSportsCamps.push(
					<SportsCampsCard
						key={sportsCamp.activityId}
						sportsCamp={sportsCamp}
					/>
				);
			});
			
			setSportsCampsCards([...sportsCampsCards, newSportsCamps]);
		}
	}, [sportsCamps.activities]);

	// Fetch API data on first render
	useEffect(() => {
		setPage(1);
		fetchSportsCamps()
		.then(() => {
			if(props.id){
				fetchInitSportkamp(props.id);
			}
		})
	}, []);

	// Avoid unnecessary API calls from rapid filter changes by user
	useDebouncedEffect(
		() => {
			setPage(1);
			fetchSportsCamps(
				freePlacesOnly,
				activityTypeSearchTermCodes,
				yearOfBirth,
				careTypeCode,
				holiday,
				from,
				until
			);
		},
		[
			freePlacesOnly,
			activityTypeSearchTermCodes,
			yearOfBirth,
			careTypeCode,
			holiday,
			from,
			until,
		],
		1000
	);

	// Also make API call when the page number changes (and avoid on first render)
	const onLoadMore = () => {
		setPage((prevState) => prevState + 1);
	};

	useDidMount(() => {
		fetchSportsCamps(page, locations);
	}, [page, locations]);

	// Avoid API call on first render + add timeout user input
	useDidMountWithTimeout(
		() => {
			setPage(1);
			fetchSportsCamps(activityNameSearchTerm);
		},
		[activityNameSearchTerm],
		500
	);

	return (
		// Use the <ActivitiesContext.Provider> wrapper where you want to use global state
		// Define global state by passing the Provider a value
		<SportsCampsContext.Provider
			value={{
				dictionaryWords,
				setDictionaryWords,
				categories,
				setCategories,
				pageId: props.pageId,

				sportsCamps,
				sportsCampsCards,
				isLoading,
				setIsLoading,
				isLoadingMore,
				setIsLoadingMore,
				page,

				setMoreInfoVisible,
				moreInfoCard,
				setMoreInfoCard,
				yearOfActivities,
				sportsCampId,
				setSportsCampId,
				fetchSportsCamp,

				yearOfBirthCounter,
				setYearOfBirthCounter,
				careTypeCounter,
				setCareTypeCounter,
				locationCounter,
				setLocationCounter,
				holidayCounter,
				setHolidayCounter,

				activityTypeSearchTermCodes,
				setActivityTypeSearchTermCodes,
				categoryButtonsActive,
				setCategoryButtonsActive,
				initCategoryButtonsActive,
				setInitCategoryButtonsActive,

				setFreePlacesOnly,
				availabilityButtonActive,
				setAvailabilityButtonActive,
				yearOfBirth,
				setYearOfBirth,
				yearOfBirthButtonActive,
				setYearOfBirthButtonActive,
				careTypeCode,
				setCareTypeCode,
				careTypeButtonActive,
				setCareTypeButtonActive,
				locations,
				setLocations,
				locationButtonsActive,
				setLocationButtonsActive,
				holiday,
				setHoliday,
				from,
				setFrom,
				until,
				setUntil,
				fromValue,
				setFromValue,
				untilValue,
				setUntilValue,
				holidayButtonActive,
				setHolidayButtonActive,
				fromButtonActive,
				setFromButtonActive,
				untilButtonActive,
				setUntilButtonActive,
			}}
		>
			<div className={`c-section c-section--fiche-sportcamp c-search js-search-sports-camps ${props.bottomSpacing ? props.bottomSpacing : ""}`}>
				<header className="c-section__header">
					<h2 className="title o-col-6">
						{!isLoading && !isLoadingDictionary && (
							<>
								{sportsCamps.totalAmount}
								<span>{` ${dictionaryWords.sportsCamps}`}</span>
							</>
						)}
					</h2>
					<div className="sportcamp__filter__search c-input col-6 o-last">
						<input
							type="text"
							className="c-input__field c-toggle-label"
							value={activityNameSearchTerm}
							onChange={(event) =>
								setActivityNameSearchTerm(event.target.value)
							}
						/>
						{activityNameSearchTerm.length === 0 && (
							<label className="c-input__label">
								{!isLoadingDictionary &&
									dictionaryWords.searchSportsCamp}
							</label>
						)}
						<i className="c-input__tooltip__trigger fa fa-fw fa-info-circle"></i>
						<div className="c-input__tooltip">
							<p className="c-input__tooltip__content">
								{!isLoadingDictionary &&
									dictionaryWords.tooltipSportsCamp}
							</p>
						</div>
					</div>
				</header>
				<div className="c-section__body">
					<nav className="c-sidebar">
						<p className="c-sidebar-nav-mobile-title">
							{!isLoadingDictionary && dictionaryWords.filters}
							<i className="fa fa-fw fa-angle-down fa-lg "></i>
						</p>
						<div className="c-sidebar-nav sportscamps__filter-m">
							{!isLoadingDictionary && (
								<>
									<AvailabliltyFilter />
									<YearOfBirthFilter />
									<CareTypeFilter />
									<LocationFilter />
									<HolidayFilter />
								</>
							)}
						</div>
					</nav>

					<div className="sportscamps__filter">
						{!isLoadingDictionary && (
							<>
								<AvailabliltyFilter />
								<YearOfBirthFilter />
								<CareTypeFilter />
								<LocationFilter query={props.query} />
								<HolidayFilter />
							</>
						)}
					</div>

					<div className="sportscamps__results two-thirds">
						<CategoryFilter />
						<SportsCampsResults loadMore={onLoadMore} />
					</div>
				</div>
			</div>
			{moreInfoCard && moreInfoVisible && <SportsCampsDetail />}
		</SportsCampsContext.Provider>
	);
};
